import type { ComponentType } from 'react'
import React from 'react'
import { IFRAME_CROSS_DOMAIN_PERMISSIONS } from '../TpaCommon/tpaConstants'

type TpaWorkerProps = {
	id: string
	src: string
	title: string
	seoHtmlContent?: string
}

const TPAWorker: ComponentType<TpaWorkerProps> = (props) => {
	const { id, src, title } = props || {}
	return (
		<div id={id}>
			<iframe
				style={{ display: 'none' }}
				name={id}
				allowFullScreen={true}
				// @ts-ignore
				allowTransparency="true"
				allowvr="true"
				frameBorder="0"
				src={src}
				title={title}
				allow={IFRAME_CROSS_DOMAIN_PERMISSIONS}
			/>
		</div>
	)
}

export default TPAWorker
